<div [class]="'info-capsule-parent ' + color">
  <div *ngIf="iconCharacter || icon" [class]="'info-capsule-icon-parent-' + iconLayout + ' ' + color">
    <span *ngIf="iconCharacter" class="info-capsule-icon">{{ iconCharacter }}</span>
    <ion-icon *ngIf="icon" class="info-capsule-icon" [name]="icon"></ion-icon>
  </div>
  <div class="info-capsule-content">
    <div *ngIf="title" [class]="'info-capsule-content-title ' + fontColor">{{ title }}</div>
    <div [class]="'info-capsule-content-body ' + fontColor">
      <ng-content></ng-content>
    </div>
  </div>
  <styled-button (onClick)="handleClick()" *ngIf="buttonLabel">{{ buttonLabel }}</styled-button>
</div>